import { render } from "./Card3.vue?vue&type=template&id=38295f69"
import script from "./Card3.vue?vue&type=script&lang=js"
export * from "./Card3.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__